module.exports = __webpack_public_path__ + "img/viva_vl.aefec24d.png";